import { Component, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { Class } from '../data/class';

@Component({
  selector: 'app-class-teachers-list',
  templateUrl: './class-teachers-list.component.html',
  styleUrls: ['./class-teachers-list.component.css']
})
export class ClassTeachersListComponent extends BaseComponent {

  @Input() class: Class;

  deleteTeacher(event, teacher): void {
    event.stopPropagation();
    this.dataService.promptDelete(`This will permanently remove ${teacher.Name} as a teacher.`)
      .then(() => {
        const newClass = { ...this.class, Teachers: [...this.class.Teachers] };
        newClass.Teachers = this.class.Teachers.filter(e => {
          return e.AccountID !== teacher.AccountID
        });
        this.deleteObj = teacher;
        this.dataService.updateClass(newClass).subscribe(result => {
          this.deleteObj = null;
          this.class.Teachers = newClass.Teachers;
        });
      });
  }
}
